export default function animateSections(sectionInitial: string, sectionFinish: string) {
    let initial = document.querySelector(`${sectionInitial}`) as HTMLElement
    let finish = document.querySelector(`${sectionFinish}`) as HTMLElement

    initial.classList.add('ar__close')
    setTimeout(() => {
        finish.classList.remove('ar__close')
    }, 800);
}